import React from "react";
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';


const QC_menus = [
    {
        label: 'sidebar.menu.qc_371',
        type: "section",
        children: [
            {
                uri: "/qc/file-upload",
                label: 'sidebar.menuItem.qc_file_upload',
                type: "nav-item",
                icon: <ChatOutlinedIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/qc/archives",
                label: 'sidebar.menuItem.qc_archives',
                type: "nav-item",
                icon: <ListAltOutlinedIcon sx={{fontSize: 20}}/>
            },
            
        ]
    },
   
];

export default QC_menus;
